// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import SocialMedia from '../components/SocialMedia'
import Features from '../components/Features'
import MoreFeatures from '../components/MoreFeatures'
import HeroBlock from '../components/HeroBlock'
import CustomDev from '../components/CustomDev'
import MobileApp from '../components/MobileApp'
import objects from '../assets/objects.png'
import { Image, Container } from 'semantic-ui-react'

class Home extends Component {
  render () {
    return (
      <div>
        <HeroBlock />
        <div className='masterdiv'>
          <Features />
          {/* <MoreFeatures /> */}
          <SocialMedia />
          <div className='overview center mtb'>
            <Image centered src={objects} size='medium' />
            <h2 className='mb'>What if I need more features?</h2>
            <CustomDev />
            <MobileApp />
          </div>
        </div>
      </div>
    )
  }
}

export default Home
